import { Call, Mail } from '../../../Assets/SVGS'
import { useTranslation } from 'react-i18next';
import './Topbar.css'
function Topbar(){
  const { t, i18n } = useTranslation();
  return(
    <div className="topbar-container container">
      <div className="topbar-content content">
        <div className="links">
          <a href="/">{t('about')}</a>
          <a href="/doctors">{t('doctors')}</a>
          <a href="/feedback">{t('feedback')}</a>
          <a
            className="lang-btn"
            onClick={() => i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}
          >             
            {i18n.language === 'en' ? ' انجليزى | عربي' : 'En | Ar'}
          </a>
        </div>
        <div className="contact">
          <a href="tel:+201111039794">
            <Call width="20px"/>
            +2 0111 103 9794
          </a>
          <a href="mailto:atefmark369@gmail.com">
            <Mail width="20px"/>
            atefmark369@gmail.com
          </a>
        </div>
      </div>
    </div>
  )
}
export default Topbar